module.exports = __webpack_public_path__ + "img/slika34.1957f1d8.jpg";